module.exports = __webpack_public_path__ + "img/f3.14ba8bc2.jpg";